module.exports = __webpack_public_path__ + "static/media/arrow-down.bf5a8e72.svg";